import FPL_CHERMESH_LOGO_WHITE from 'assets/images/fpl-chermesh-logo-white.png'
import React, { type Dispatch } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { generalRoutes } from 'Routing'
import { redirect } from 'utils/general'
import { useTheme, useMediaQuery, Box } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { clearTeamData } from 'store/slices/userSlice'
import { clearUserInsightsCache } from 'utils/insightsCache'
import type { RootState } from 'types/store'

export const Logo: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const dispatch: Dispatch<any> = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const userId = useSelector((state: RootState) => state.user.teamData?.id)

  const onLogoClick = (): void => {
    if (userId != null) {
      clearUserInsightsCache(userId)
    }
    dispatch(clearTeamData())
    redirect(navigate, generalRoutes.ROOT)
  }

  return (
    <Box
      sx={{
        marginRight: { xs: '8px', sm: '15px' },
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        height: { xs: '28px', sm: '40px' },
        '& img': {
          height: '100%',
          width: 'auto',
          maxWidth: 'none'
        }
      }}
      onClick={onLogoClick}
    >
      <img
        src={FPL_CHERMESH_LOGO_WHITE}
        alt='MAIN ICON'
      />
    </Box>
  )
}
